import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from '../../../../cms/blocks/types.gen'
import { Form } from '../../../../form'
import { FormState } from '../../../../form/types'
import { InnerHtmlWrapper } from '../../../../utils/InnerHtmlWrapper'
import { campaignMonitorBlock } from '../types.mod'

export type CampaignMonitorBlockProps = {
  block_index: number
  form_id: string
  form_title: string
  form_intro: string
  state: FormState
  collapsed_status: 'no_collapse' | 'collapse_open' | 'collapse_closed'
}

export type CampaignMonitorBlockStyle = {}

export function campaignMonitorBlock(
  props: CampaignMonitorBlockProps,
  options?: { style: CampaignMonitorBlockStyle; key?: string }
): (
  s: CMSState
) => IOWidget<PublicSiteState, Updater<CMSState>> {
  // Incorrect implementation
  // if (props.form_title.toLowerCase().includes("job alerts")) { // TODO may need to move to new block
  //   return _ => _ => jobAlertsBlock(getLangFromUrl()).never()
  // }
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((setState) => (
        <section className="block block--form block--job ls-block-spacing">
          <div className="block__inner ls-container">
            <div className="block__layout ls-columns">
              <header className="block__header ls-columns__header">
                <h2 className="block__title title--l">{props.form_title}</h2>
                {props.collapsed_status != 'no_collapse' ? (
                  <button
                    onClick={() => {
                      setState((s) => {
                        let currentBlock = s.blocks.get(props.block_index)
                        if (currentBlock == undefined) return s
                        if (currentBlock.kind === 'campaignMonitorBlock') {
                          currentBlock = {
                            ...currentBlock,
                            value: [
                              {
                                ...currentBlock.value[0],
                                collapsed_status:
                                  currentBlock.value[0].collapsed_status == 'collapse_open'
                                    ? ('collapse_closed' as 'collapse_closed')
                                    : ('collapse_open' as 'collapse_open')
                              },
                              currentBlock.value[1]
                            ]
                          }
                        }
                        return { ...s, blocks: s.blocks.set(props.block_index, currentBlock) }
                      })
                    }}
                    className={`link`}
                  >
                    {props.collapsed_status == 'collapse_open' ? 'Collapse job alert form' : 'Sign up for job alert'}
                  </button>
                ) : null}
                {props.form_intro && props.form_intro.length > 0 ? (
                  <>
                    {/* <div className="block__text text--styled text--spacing" dangerouslySetInnerHTML={{ __html: props.form_intro }}/> */}
                    <InnerHtmlWrapper className="block__text text--styled text--spacing" text={props.form_intro} />
                  </>
                ) : (
                  <></>
                )}
              </header>
              
              <div className="ls-columns__main">
                {Form(props.state).run((updater) => {
                  setState((s) => {
                    const currentBlock = s.blocks.get(props.block_index)
                    if (currentBlock == undefined || currentBlock.kind !== 'campaignMonitorBlock') return s
                    const new_state = updater(currentBlock.value[0].state)
                    const newBlock = {
                      ...currentBlock,
                      value: [
                        { ...currentBlock.value[0], state: { ...new_state } },
                        currentBlock.value[1]
                      ]
                    } as campaignMonitorBlock
                    return { ...s, blocks: s.blocks.set(props.block_index, newBlock) }
                  })
                })}
              </div>
            </div>
          </div>
        </section>
      )
    )
}
